import React, { useState, useEffect } from "react";
import {
  Grid,
  Container,
  Button,
  Typography,
  FormControl,
  FormHelperText,
  InputAdornment,
  IconButton,
  FormControlLabel,
  Checkbox,
  Divider
} from "@mui/material";
import FabMuiTable from "../utils/MuiTable";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import InputLabel from "@mui/material/InputLabel";
import Box from "@mui/material/Box";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { MobileDateTimePicker } from "@mui/x-date-pickers/MobileDateTimePicker";
import EditIcon from "@mui/icons-material/Edit";
import { uploadMomsResources, getFilesFromFolder } from "../../apis/Misc";
import {
  getFeatures,
  getInstances,
  insertMomsEntry,
  getStaffs,
  uploadMomsImage
} from "../../apis/MoMs";
import moment from "moment";
import PromptModal from "./modals/PromptModal";
import { makeStyles } from "@material-ui/core/styles";
import MomsTable from "./MomsTable";
import ListItemText from "@mui/material/ListItemText";
import Swal from "sweetalert2";

const CBEWSL_SITE_CODE = `${process.env.REACT_APP_SITE_CODE}`;

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      margin: theme.spacing(1),
    },
  },
  textarea: {
    resize: "both",
  },
}));

const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: 200,
      width: 250,
    },
  },
};

const Moms = (props) => {
  const classes = useStyles();

  const [open, setOpen] = useState(false);
  const [consulted, setConsulted] = useState(false);
  const [dynaName, setDynaName] = useState("");

  const [datetimestamp, setDateTimestamp] = useState(new Date());
  const [selectedFeatureIndex, setSelectedFeatureIndex] = useState(null);
  // const [selectedFeatureName, setSelectedFeatureName] = useState("");
  const [selectedAlertLevel, setSelectedAlertLevel] = useState(null);
  const [selectedAlertLevelFromDyna, setSelectedAlertLevelFromDyna] =
    useState(null);
  const [narrative, setNarrative] = useState("");
  const [featureDetails, setFeatureDetails] = useState("");
  const [featureLocation, setFeatureLocation] = useState("");
  // const [reporter, setReporter] = useState({
  //   user_id: "",
  //   first_name: "",
  //   last_name: "",
  // });
  const [featureName, setFeatureName] = useState({});
  const [featureNames, setFeatureNames] = useState([
    {
      name: "New Feature",
      instance_id: null,
      location: "",
    },
  ]);

  const [instances, setInstances] = useState([]);
  const [staffs, setStaffs] = useState([]);

  //default muna since wala pang smth
  const [userId, setUserId] = useState(null);
  const [image, setImage] = useState(null);
  const [file_name, setFileName] = useState("");

  const onImageChange = (event) => {
    if (event.target.files && event.target.files[0]) {
      setImage(URL.createObjectURL(event.target.files[0]));

      const formData = new FormData();
      const selected_file = event.target.files[0];
      setFileName(selected_file.name);
      formData.append("file", selected_file);

      uploadMomsImage(formData, (data) => {
        const { status, message } = data;
        if (status) {
          console.log("upload success");
        } else {
          console.log("Error upload", message);
        }
      });
    }
  };

  useEffect(() => {
    let credentials = JSON.parse(localStorage.getItem("umi_credentials"));
    setUserId(credentials.user.user_id);
  }, []);

  const feature_list = [
    {
      feature_id: 1,
      feature: "Crack",
      details:
        "Ilang crack ang nakita?: " +
        "\nGaano kahaba?: " +
        "\nGaano kalapad?: " +
        "\nAno ang lalim nito?: " +
        "\nAno ang oryentasyon o direksyon?: " +
        "\nGaano kalaki ang pagbabago? (Kung luma): ",
    },
    {
      feature_id: 2,
      feature: "Scarp",
      details:
        "Ilang scarp ang nakita?: " +
        "\nGaano kahaba?: " +
        "\nGaano kalapad?: " +
        "\nAno ang taas nito?: " +
        "\nAno ang oryentasyon o direksyon?: " +
        "\nGaano kalaki ang pagbabago?(Kung luma): ",
    },
    {
      feature_id: 3,
      feature: "Seepage",
      details:
        "Gaano kabilis/kalakas ang daloy ng tubig?: " +
        "\nGaano karami ang tubig na umaagos?: " +
        "\nAno ang kulay ng tubig?: " +
        "\nAno ang oryentasyon o direksyon ng daloy ng tubig?: " +
        "\nMayroon bang seepage kahit wala nang pag-ulan?: ",
    },
    {
      feature_id: 4,
      feature: "Ponding",
      details:
        "Gaano kalaki ang ponding?: " +
        "\nGaano kalalim ang ponding?: " +
        "\nMayroon bang kalapit na iba pang landslide feature?: " +
        "\nBagong ponding o dati pa?: ",
    },
    {
      feature_id: 5,
      feature: "Tilted/Split Trees",
      details:
        "Saang direksyon nakatagilid/nakatabingi/nahati ang puno?: " +
        "\nGaano kalaking area ang naapektuhan nito?: " +
        "\nPara sa split trees, gaano kalaki ang hati?: ",
    },
    {
      feature_id: 6,
      feature: "Damaged Structures",
      details:
        "Mayroon bang mga paglubog sa sahig o pagtagilid ng mga dingding?: " +
        "\nKung may crack, saan nakita ang crack at ano ang oryentasyon nito?: " +
        "\nSino ang may-ari ng istrukturang ito?: ",
    },
    {
      feature_id: 7,
      feature: "Localized Failure",
      details:
        "Saang bahagi ng slope ito na-obserbahan?: " +
        "\nGaano ito kataas at kalapad?: " +
        "\nGaano kalayo ang narating ng pagguho ng lupa?: " +
        "\nMalalim o mababaw ba ang localized failure? " +
        "\nMayroon bang mga naapektuhang istruktura?: ",
    },
    {
      feature_id: 8,
      feature: "Bulging/Depression",
      details:
        "Ilan ang nakitang pag-umbok o paglubog ng lupa?: " +
        "\nGaano ito kalaki?: " +
        "\nGaano ito kalalim o kataas?: " +
        "\nMayroon bang kalapit na iba pang landslide feature?: ",
    },
    {
      feature_id: 9,
      feature: "No Changes Observed",
      details:
        "",
    },
  ];

  useEffect(() => {
    if (selectedFeatureIndex === 9) {
      setFeatureName({
        name: "None",
        instance_id: null,
        location: "",
      });
      setFeatureNames([
        {
          name: "None",
          instance_id: null,
          location: "",
        },
      ]);
      setFeatureDetails(""); 
      return;
    }
    setFeatureName("");

    getFeatures((response) => {
      if (response.status) {
        let tempData = response.data;

        tempData.map((feature) => {
          if (feature.feature_id == selectedFeatureIndex) {
            let tempFeatureNames = [
              {
                name: "New Feature",
                instance_id: null,
                location: "",
              },
            ];

            if (feature.instances.length > 0) {
              feature.instances.map((instance) => {
                tempFeatureNames.push({
                  instance_id: instance.instance_id,
                  name: instance.feature_name,
                  location: instance.location == null ? "" : instance.location,
                });
              });
            }

            setFeatureNames(tempFeatureNames);
          }
        });
      }
    });

    setFeatureDetails(
      selectedFeatureIndex != null
        ? feature_list.find((o) => o.feature_id == selectedFeatureIndex).details
        : ""
    );
  }, [selectedFeatureIndex]);

  useEffect(() => {
    reloadTable();
  }, [props]);

  const reloadTable = () => {
    getInstances((response) => {
      if (response) {
        setInstances(response);
      }
    });

    getStaffs((response) => {
      setStaffs(response.data);
    });
  };

  const handleUpload = (uploadImage) => {
    const formData = new FormData();
    formData.append("file", uploadImage);
    formData.append("folder", "moms_images");

    uploadMomsResources(formData, (data) => {
      const { status, message } = data;
      if (status) {
        getFilesFromFolder("moms_images", (response) => {
          // setFiles(response)
        });
      } else {
        console.log("Error upload", message);
      }
    });
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    initialize();
    setOpen(false);
  };

  const initialize = () => {
    setDateTimestamp(new Date());
    setSelectedFeatureIndex(null);
    setSelectedAlertLevel(null);
    setFeatureDetails("");
    setNarrative("");
    setDynaName("");
    // setReporter({
    //   user_id: "",
    //   first_name: "",
    //   last_name: "",
    // });
    setFeatureName({});
    setFeatureNames([
      {
        name: "New Instance",
        instance_id: null,
        location: "",
      },
    ]);
    setIncomplete(false);
  };

  const [incomplete, setIncomplete] = useState(false);
  const checkRequired = () => {
    if (selectedAlertLevel == null || selectedFeatureIndex == null) return false;
    if (selectedAlertLevelFromDyna == null || selectedFeatureIndex == null)
      return false;  
    if (selectedFeatureIndex !== 9) {
      if (featureName.instance_id == null && featureName.location == "") return false;
      if (!featureName.hasOwnProperty("instance_id")) return false;
      if (featureDetails == "") return false;
    }
  
    if (narrative == "" || dynaName == "") return false;
  
    return true;
  };

  const submitMoms = () => {
    let moms_entry = {
      site_code: CBEWSL_SITE_CODE,
      moms_list: [
        {
          alert_level: selectedAlertLevel,
          instance_id: featureName.instance_id,
          feature_name:
            featureName.instance_id == null ? null : featureName.name,
          feature_type: feature_list.find(
            (o) => o.feature_id == selectedFeatureIndex
          ).feature,
          report_narrative: featureDetails,
          observance_ts: moment(new Date(datetimestamp)).format(
            "YYYY-MM-DD HH:mm:ss"
          ),
          remarks: narrative,
          reporter_id: 1243, //default muna, need mag create ng general community account
          validator_id: userId,
          location: featureName.location,
          iomp: userId,
          file_name,
          dynaName: dynaName,
          recommended_alert_level: selectedAlertLevelFromDyna,
        },
      ],
      uploads: [],
    };
    console.log("moms_entry", moms_entry);

    insertMomsEntry(moms_entry, (response) => {
      if (response.status == true) {
        initialize();
        reloadTable();
        Swal.fire({
          icon: "success",
          title: "Success!",
          text: "Landslide Feature saved!",
          confirmButtonColor: "#1976d2"
        });
        setOpen(false);
      } else {
        Swal.fire({
          icon: "error",
          title: "Error!",
          text: "Error on saving landslide feature, please contact developers",
          confirmButtonColor: "#1976d2"
        });
      }
    });
  };

  const handleSubmit = () => {
    let valid = checkRequired();

    if (valid) {
      let promptMsg = `Date: ${moment(new Date(datetimestamp)).format(
        "YYYY-MM-DD HH:mm:ss"
      )}\n`;
      promptMsg += `Feature Type: ${
        feature_list.find((o) => o.feature_id == selectedFeatureIndex).feature
      }\n`;
      if (featureName.instance_id != null)
        promptMsg += `Feature Name: ${featureName.name}\n`;
      promptMsg += `Location: ${featureName.location}\n`;
      promptMsg += `Description: ${featureDetails}\n`;
      promptMsg += `Narratives: ${narrative}\n`;
      promptMsg += `Validator: ${dynaName}\n`;
      promptMsg += `Recommended Alert Level: ${selectedAlertLevelFromDyna}\n`;
      promptMsg += `Determined Alert Level: ${selectedAlertLevel}`;

      setConfirmation(true);
      // setOpen(false);
      setOpenPrompt(true);
      setErrorPrompt(false);
      setPromptTitle("Please confirm inputs: ");
      setNotifMessage(promptMsg);
    } else {
      setIncomplete(true);
    }
  };

  const [openPrompt, setOpenPrompt] = useState(false);
  const [promptTitle, setPromptTitle] = useState("");
  const [notifMessage, setNotifMessage] = useState("");
  const [errorPrompt, setErrorPrompt] = useState(false);
  const [confirmation, setConfirmation] = useState(false);

  return (
    <Grid sx={{ px: 10, paddingTop: 2 }}>
      <PromptModal
        isOpen={openPrompt}
        error={errorPrompt}
        title={promptTitle}
        setOpenModal={setOpenPrompt}
        notifMessage={notifMessage}
        confirmation={confirmation}
        callback={(response) => {
          if (response) {
            submitMoms();
          }
        }}
      />

      <Dialog
        open={open}
        onClose={handleClose}
        fullWidth
        style={{ zIndex: 1059 }}
      >
        <DialogTitle>Enter new landslide feature</DialogTitle>
        <DialogContent>
          <Grid item xs={12} style={{ paddingTop: 10 }}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <MobileDateTimePicker
                label="Date and Time Observed"
                value={datetimestamp}
                onChange={(e) => {
                  setDateTimestamp(e);
                }}
                renderInput={(params) => (
                  <TextField
                    style={{ width: "100%", paddingBottom: 15 }}
                    {...params}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton edge="end">
                            <EditIcon />
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                )}
              />
            </LocalizationProvider>
          </Grid>
          <Grid item xs={12}>
            <Grid container spacing={2} alignItems="center">
              <Grid  item xs={8}>
                <FormControl
                  fullWidth
                  style={{ width: "100%", paddingBottom: 15 }}
                  error={incomplete && selectedFeatureIndex == null}
                >
                <InputLabel id="demo-simple-select-label">
                  Feature Type
                </InputLabel>
                <Select
                  error={incomplete && selectedFeatureIndex == null}
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  label="Feature Type"
                  value={selectedFeatureIndex}
                  onChange={(e) => {
                    setSelectedFeatureIndex(e.target.value);
                    // setSelectedFeatureName(
                    //   selectedFeatureIndex != null
                    //     ? feature_list.find(
                    //         (o) => o.feature_id == selectedFeatureIndex
                    //       ).feature
                    //     : ""
                    // );
                  }}
                >
                {feature_list &&
                  feature_list.map((row, index) => (
                    <MenuItem key={index} value={row.feature_id}>
                      {row.feature}
                    </MenuItem>
                  ))}
                </Select>
                <FormHelperText>
                  {incomplete && selectedFeatureIndex == null && "Required"}
                </FormHelperText>
              </FormControl>
            </Grid>

            <Grid  item xs={4}>
              <FormControl fullWidth style={{ width: "100%", }}>
                <input
                  accept="image/*"
                  style={{ display: "none" }}
                  id="raised-button-file"
                  type="file"
                  multiple
                  onChange={onImageChange}
                />
                <label
                  htmlFor="raised-button-file"
                  style={{ textAlign: "center", marginBottom: 13 , }}
                >
                  <Button variant="contained" component="span" style={{ mx: 1 }}>
                    Upload Image
                  </Button>
                </label>
              </FormControl>
            </Grid>
              <div>
              {image && <img src={image} alt="moms image" style={{ width: "100%", height: "auto", marginBottom: 30, marginLeft: 8}} />}
              </div>
            </Grid>
          </Grid>
          {selectedFeatureIndex !== 9 && (
          <Grid item xs={12}>
              <FormControl
                fullWidth
                style={{ width: "100%", paddingBottom: 15 }}
                error={incomplete && !featureName.hasOwnProperty("instance_id")}
              >
                <InputLabel id="demo-simple-select-label">
                  Feature Name
                </InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  label="Feature Name"
                  value={featureName.name}
                  onChange={(e) => {
                    setFeatureName(e.target.value);
                  }}
                >
                  {featureNames.map((row, index) => (
                    <MenuItem key={index} value={row}>
                      {row.name}
                    </MenuItem>
                  ))}
                </Select>
                <FormHelperText>
                  {incomplete &&
                    !featureName.hasOwnProperty("instance_id") &&
                    "Required"}
                </FormHelperText>
              </FormControl>
          </Grid>
          )}

          {selectedFeatureIndex !== 9 && featureName.hasOwnProperty("instance_id") && (
            <Grid item xs={12}>
              <TextField
                error={
                  incomplete &&
                  featureName.instance_id == null &&
                  featureName.location == ""
                }
                helperText={
                  incomplete &&
                  featureName.instance_id == null &&
                  featureName.location == "" &&
                  "Required"
                }
                id="outlined-required"
                label="Location"
                variant="outlined"
                style={{ width: "100%", paddingBottom: 15 }}
                value={featureName.location}
                onChange={(e) => {
                  setFeatureName({
                    ...featureName,
                    location: e.target.value,
                  });
                }}
                disabled={featureName.instance_id != null}
              />
            </Grid>
          )}
          {selectedFeatureIndex !== 9 && (
          <Grid item xs={12}>
            <TextField
              error={incomplete && featureDetails == ""}
              helperText={incomplete && featureDetails == "" && "Required"}
              id="outlined-required"
              label="Feature Description"
              variant="outlined"
              style={{ width: "100%", paddingBottom: 15 }}
              value={featureDetails}
              onChange={(e) => {
                setFeatureDetails(e.target.value);
              }}
              multiline
              rows={6}
            />
          </Grid>
          )}
          <Grid item xs={12}>
            <TextField
              error={incomplete && narrative == ""}
              helperText={incomplete && narrative == "" && "Required"}
              id="outlined-required"
              label="Narratives"
              placeholder="According to LEWC Juan Dela Cruz, a crack appeared behind his house, with a length of 1 meter and an opening of 2 cm. It appeared around 9AM after the heavy rainfall."
              variant="outlined"
              style={{ width: "100%", paddingBottom: 10 }}
              value={narrative}
              onChange={(e) => {
                setNarrative(e.target.value);
              }}
              multiline
              rows={4}
            />
          </Grid>

          {/* <Grid item xs={12}>
            <FormControl fullWidth style={{ width: "100%", paddingBottom: 15 }}>
              <InputLabel id="demo-simple-select-label">Reporter</InputLabel>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                label="Reporter"
                value={`${reporter.first_name} ${reporter.last_name}`}
                onChange={(e) => {
                  setReporter(e.target.value);
                }}
                renderValue={(selected) => selected}
                MenuProps={MenuProps}
              >
                {staffs.map((staff) => (
                  <MenuItem
                    key={staff.user_id}
                    // value={`${staff.first_name} ${staff.last_name}`}
                    value={staff}
                  >
                    <ListItemText
                      primary={`${staff.first_name} ${staff.last_name}`}
                    />
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid> */}

          <Grid>
            <FormControlLabel
              // required
              control={
                <Checkbox
                  checked={consulted}
                  onChange={(e) => {
                    setConsulted(e.target.checked);
                    setSelectedAlertLevel(null);
                  }}
                />
              }
              label={
                <Typography
                  style={{
                    color: consulted ? 'black' : 'red', 
                  }}
                >
                  Have you consulted Dynaslope?
                </Typography>
              }
            />
            {consulted && (
              <Grid container spacing={2}>
                <Grid item xs={6}>
                  {consulted && (
                    <TextField
                      error={incomplete && dynaName == ""}
                      helperText={incomplete && dynaName == "" && "Required"}
                      label="Name of Dynaslope Staff Consulted"
                      variant="outlined"
                      fullWidth
                      margin="normal"
                      value={dynaName}
                      onChange={(e) => setDynaName(e.target.value)}
                      style={{
                        width: "100%",
                        marginTop: 10,
                      }}
                    />
                  )}
                </Grid>
                <Grid item sm={6} xs={6}>
                  {consulted && (
                    <FormControl
                      fullWidth
                      variant="outlined"
                      style={{
                        width: "100%",
                        marginTop: 10,
                      }}
                    >
                      <InputLabel id="alert-level-label">
                        Recommended alert level
                      </InputLabel>
                      <Select
                        labelId="alert-level-label"
                        id="alert-level-select"
                        value={selectedAlertLevelFromDyna}
                        onChange={(e) =>
                          setSelectedAlertLevelFromDyna(e.target.value)
                        }
                        label="Recommended alert level" // must match InputLabel text
                        disabled={!consulted}
                        error={incomplete && selectedAlertLevelFromDyna == null}
                      >
                        <MenuItem value={0}>Alert level 0</MenuItem>
                        <MenuItem value={2}>Alert level 2</MenuItem>
                        <MenuItem value={3}>Alert level 3</MenuItem>
                      </Select>
                      <FormHelperText>
                        {incomplete &&
                          selectedAlertLevelFromDyna == null &&
                          "Required"}
                      </FormHelperText>
                    </FormControl>
                  )}
                </Grid>
              </Grid>
            )}
            <Divider style={{ paddingBottom: 10 }} />
            <FormControl
              fullWidth
              style={{ width: "100%", paddingBottom: 15, marginTop: 10 }}
              error={incomplete && selectedAlertLevel == null}
            >
              <InputLabel id="demo-simple-select-label">Alert Level</InputLabel>
              <Select
                value={selectedAlertLevel}
                disabled={!consulted}
                error={incomplete && selectedAlertLevel == null}
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                label="Alert level"
                onChange={(e) => {
                  setSelectedAlertLevel(e.target.value);
                }}
              >
                <MenuItem key={0} value={0}>
                  Alert level 0
                </MenuItem>
                <MenuItem key={2} value={2}>
                  Alert level 2
                </MenuItem>
                <MenuItem key={3} value={3}>
                  Alert level 3
                </MenuItem>
              </Select>
              <FormHelperText>
                {incomplete && selectedAlertLevel == null && "Required"}
              </FormHelperText>
              <FormHelperText>
                * Alert level determined by the MDRRMO Alimodian
              </FormHelperText>
            </FormControl>
          </Grid>
          
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="error">
            Cancel
          </Button>
          <Button onClick={handleSubmit} variant="contained">
            Add Landslide Feature
          </Button>
        </DialogActions>
      </Dialog>

      <Grid container spacing={4} sx={{ mt: 2, mb: 6, padding: "2%" }}>
        <Grid item xs={12}>
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <Typography variant="h4">Landslide Features</Typography>
            </Grid>
            <Grid item xs={6}>
              <Button
                variant="contained"
                onClick={handleClickOpen}
                style={{
                  backgroundColor: "#2E2D77",
                  color: "white",
                  float: "right",
                }}
              >
                Add Landslide Feature
              </Button>
            </Grid>
            <MomsTable instances={instances} />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default Moms;
